// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"ccb27b21","104":"880fe75f","453":"c710b4ea","598":"678b77bf","625":"709b5738","643":"4669ae71","902":"d08f9d2d"}[chunkId] + ".chunk.js";
};